import type { JSX } from 'react';
import { styled } from 'styled-components';
import { isNotNil } from '@wistia/type-guards';

const StyledThumbnailBadge = styled.div`
  align-items: center;
  background-color: rgb(0 0 0 / 50%);
  border-radius: var(--wui-border-radius-01);
  bottom: var(--wui-thumbnail-badge-offset, var(--wui-space-01));
  color: var(--wui-color-text-on-fill);
  display: flex;
  font-size: var(--wui-typography-body-4-size);
  font-weight: var(--wui-typography-weight-body-bold);
  gap: var(--wui-space-01);
  padding: 0 var(--wui-space-01);
  position: absolute;
  right: var(--wui-thumbnail-badge-offset, var(--wui-space-01));
  z-index: 1;

  svg {
    height: 12px;
    width: 12px;
    flex: 0 0 12px;

    path {
      color: var(--wui-color-icon-on-fill);
    }
  }
`;

export type ThumbnailBadgeProps = {
  /**
   * Icon to display on the left side of the badge
   */
  icon?: JSX.Element | undefined;
  /**
   * Text content to display in the badge
   */
  label: string;
};

export const ThumbnailBadge = ({ icon, label, ...props }: ThumbnailBadgeProps): JSX.Element => {
  return (
    <StyledThumbnailBadge {...props}>
      {isNotNil(icon) && icon}
      <span>{label}</span>
    </StyledThumbnailBadge>
  );
};

ThumbnailBadge.displayName = 'ThumbnailBadge';
